import Amplify, { API, Auth, Hub } from 'aws-amplify';
import awsConfig from './aws-exports';


const isLocalhost = Boolean(window.location.hostname == 'localhost');

const [
	productionRedirectSignIn,
	localRedirectSignIn,
] = awsConfig.oauth.redirectSignIn.split(",");

const [
	productionRedirectSignOut,
	localRedirectSignOut,
] = awsConfig.oauth.redirectSignOut.split(",");

export default {
	amplify: Amplify.configure({
		...awsConfig,
		oauth: {
			...awsConfig.oauth,
			redirectSignIn: isLocalhost ? localRedirectSignIn : productionRedirectSignIn,
			redirectSignOut: isLocalhost ? localRedirectSignOut : productionRedirectSignOut
		}
	}),
	isLocalhost: isLocalhost,
	baseTitle: 'Rate My Disease',
	defaultTitle: 'ALL YOUR BASE',
	defaultDescription: 'Disease is not fun. Zero stars overall.',
	defaultImage: 'https://www.ratemydisease.com/bacteria.svg'
};
